import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { PageHeader, Card } from "@/components/Primitives";

const Audit = () => {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/audit/logs?limit=200").then((r) => setRows(r.data.rows || [])); }, []);

  return (
    <div>
      <PageHeader
        eyebrow="Audit"
        title="What happened"
        subtitle="Every login, every upload, every export — accounted for."
      />
      <Card testId="audit-table">
        <div className="overflow-auto max-h-[70vh] scrollbar-thin">
          <table className="w-full text-sm">
            <thead className="sticky top-0 bg-white/95">
              <tr className="text-left">
                {["When", "User", "Action", "Module", "Meta"].map((h) => (
                  <th key={h} className="py-2 px-3 text-[10px] uppercase tracking-[0.2em] text-myb-500 font-semibold">{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {rows.map((r) => (
                <tr key={r.id} className="border-t hairline hover:bg-myb-50/50">
                  <td className="py-2 px-3 text-xs text-muted-foreground whitespace-nowrap">{new Date(r.created_at).toLocaleString()}</td>
                  <td className="py-2 px-3">
                    {r.user_name || r.user_email ? (
                      <div className="flex flex-col">
                        <span className="text-sm text-foreground font-medium">{r.user_name || r.user_email}</span>
                        {r.user_name && r.user_email && (
                          <span className="text-[10px] text-muted-foreground">{r.user_email}</span>
                        )}
                        {r.user_role && (
                          <span className="text-[9px] uppercase tracking-wider text-myb-500 font-semibold mt-0.5">{r.user_role.replace("_", " ")}</span>
                        )}
                      </div>
                    ) : (
                      <span className="font-mono text-[10px] text-muted-foreground italic">
                        {r.user_id ? `${r.user_id.slice(0, 8)} (deleted)` : "system"}
                      </span>
                    )}
                  </td>
                  <td className="py-2 px-3 text-myb-500">{r.action}</td>
                  <td className="py-2 px-3 text-xs uppercase tracking-wider">{r.module}</td>
                  <td className="py-2 px-3 text-xs text-muted-foreground font-mono truncate max-w-[400px]">{JSON.stringify(r.meta || {})}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Card>
    </div>
  );
};

export default Audit;
